export default __webpack_public_path__ + "static/media/05_08.2ecde806.jpg";